/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

type MenuItem = {
    1: string; // Title
    2: string; // ID
};

type MenuListProps = {
    menu?: Record<number, MenuItem>;
    bgColor?: string;
};

const MenuList = ({ menu, bgColor }: MenuListProps) => {
    if (!menu || Object.keys(menu).length === 0) return null;

    const defaultColor = "#FFE833";
    const items = Object.entries(menu);
    const itemsPerRow = 3;
    const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;

    const menuRowStyle = (justify: string) => css`
        display: flex;
        justify-content: ${justify};
        align-items: flex-start;
        flex-wrap: nowrap;
        gap: 5%;
        width: 100%;
        margin-bottom: 10px;

        @media (max-width: 768px) {
        flex-wrap: wrap;   /* allow wrapping */
        justify-content: space-between; /* clean 2-column layout */
        gap: 3%;
        }
    `;

    const menuItemStyle = (color?: string) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 30%;
        height: 3vw;
        background-color: ${color || defaultColor};
        font-size: 1.2rem;
        color: #333;
        cursor: pointer;
        text-decoration: none;
        border-radius: 5px;
        transition: color 0.3s ease;

        @media (max-width: 768px) {
        min-width: 41vw;
        height: 5vw;
        font-size: 2.8vw;
        flex: 0 0 41vw;
        margin: 1vw 0;
        }

        &:hover {
        color: #FF8900;
        }
    `;

    const menuLinkStyle = css`
        text-decoration: none;
        color: inherit;
    `;

    // Split items into rows of 3
    const rows = isMobile
    ? [items] // ★ single row container
    : (() => {
        const r = [];
        for (let i = 0; i < items.length; i += itemsPerRow) {
            r.push(items.slice(i, i + itemsPerRow));
        }
        return r;
        })();

    return (
        <div css={css`width: 100%; padding: 2vw 6.944vw calc(2vw - 10px) 6.944vw;`}>
        {rows.map((row, rowIndex) => {
            const rowNumber = rowIndex + 1;
            const justify =
            rowNumber % 3 === 2 ? "flex-start" : "center"; // 2nd, 5th, 8th row pattern

            return (
            <div key={rowIndex} css={menuRowStyle(justify)}>
                {row.map(([key, value], index) => {
                const item = value[1];
                const id = value[2];
                if (!item || !id) return null;

                return (
                    <div key={index} css={menuItemStyle(bgColor)}>
                    <a href={`#${id}`} css={menuLinkStyle}>
                        {item}
                    </a>
                    </div>
                );
                })}
            </div>
            );
        })}
        </div>
    );
};

export default MenuList;
